<df-tactic-columns [funnelTactic]="tactic"></df-tactic-columns>
